import type { TrainingLessonCanonicalContent } from './trainingLessonContent.types';

export const core1RestoreEs: TrainingLessonCanonicalContent = {
  intro:
    'La Restauración del Evangelio de Jesucristo es el acontecimiento más importante desde la resurrección del Salvador. En esta lección explorarás sus fundamentos y cómo aplicarlos en tu vida.',
  objectivesHeading: 'Objetivos',
  objectives: [
    'Comprender qué significa la Restauración del Evangelio',
    'Identificar los eventos clave de la Restauración',
    'Reconocer el papel del Libro de Mormón como evidencia',
    'Reflexionar sobre cómo la Restauración impacta tu vida',
  ],
  briefHeading: 'La Restauración en breve',
  briefBody:
    'Tras siglos de apostasía, el Padre Celestial y Jesucristo se manifestaron a José Smith en la primavera de 1820. A través de él se restauraron la autoridad del sacerdocio, las ordenanzas y las escrituras adicionales, incluyendo el Libro de Mormón.',
  scripturesHeading: 'Escrituras clave',
  scriptures: [
    {
      ref: 'José Smith—Historia 1:17',
      text: 'Vi a dos Personajes, cuyo fulgor y gloria desafían toda descripción...',
    },
    {
      ref: 'Doctrina y Convenios 1:30',
      text: 'Y también aquellos a quienes se dieron mandamientos de ir adelante y establecer la causa de Sión',
    },
    {
      ref: 'Artículos de Fe 1:6',
      text: 'Creemos en la misma organización que existió en la Iglesia Primitiva...',
    },
  ],
  didYouKnowHeading: '¿Sabías que…?',
  didYouKnow: [
    'La Primera Visión ocurrió cuando José Smith tenía 14 años, en un bosque cerca de su hogar en Palmyra, Nueva York.',
    'El Libro de Mormón se publicó en 1830, diez años después de la Primera Visión, como evidencia tangible de la Restauración.',
  ],
  practiceHeading: 'Práctica',
  practiceHint: 'Marca las actividades que completes (se guardan automáticamente)',
  practiceItems: [
    'Leer José Smith—Historia 1:1–20',
    'Meditar sobre una pregunta que te gustaría hacer al Señor',
    'Compartir con alguien qué significa para ti la Restauración',
    'Revisar el prólogo del Libro de Mormón',
  ],
  practiceDone: 'Completado',
  practicePending: 'Pendiente',
  reflectionHeading: 'Preguntas de reflexión',
  reflectionHint: 'Escribe tus pensamientos (se guardan automáticamente)',
  reflectionQuestions: [
    '¿Qué aspecto de la Restauración te resulta más significativo en este momento?',
    '¿Cómo te ayuda el Libro de Mormón a conocer que la Restauración es verdadera?',
    '¿Qué puedes hacer esta semana para fortalecer tu testimonio de la Restauración?',
  ],
  reflectionPlaceholder: 'Escribe aquí...',
  actionHeading: 'Acción esta semana',
  actionText:
    'Comparte con un familiar o amigo una experiencia en la que hayas sentido que el Evangelio restaurado te ha bendecido.',
};
